<dff-side [observable]="vm$">
  @if (vm$ | async; as vm) {
    <dff-side-titel>{{ vm.indstillinger.menuTekst }}</dff-side-titel>
    <panel aria-labelledby="page-header">
      <div>
        <h2>{{ vm.kontakt.navn }}</h2>
      </div>
      <div>{{ vm.kontakt.adresse }}</div>
      <div>{{ vm.kontakt.postNr }} {{ vm.kontakt.by }}</div>
      <div>
        <label>CVR-nr.:</label>
        <span>{{ vm.kontakt.cvrNr }}</span>
      </div>
      <div>
        <label>Hjemmeside:</label>
        <a href="http://{{ vm.kontakt.website }}">
          {{ vm.kontakt.website }}
        </a>
      </div>
      <div>
        <label>Mail:</label>
        <a href="mailto:{{ vm.kontakt.mail }}">
          {{ vm.kontakt.mail }}
        </a>
      </div>
      <div>
        <label>Telefon:</label>
        <a href="tel:{{ vm.kontakt.telefonNr }}">
          {{ vm.kontakt.telefonNr }}
        </a>
      </div>
    </panel>
  }
</dff-side>
